// Spades' client registry entry (see ../registry.ts and docs/games-contract.md).

import { Spade } from 'lucide-react';
import { CardTableSet } from '../CardTableModel';
import { seatXZ, seatYaw } from '../tableLayout';
import { SPADES_RULES, SPADES_TUTORIAL_TITLE, SPADES_TUTORIAL_URL } from '../spadesRules';
import { SEAT_NAMES } from '../../../../supabase/functions/games/spades.ts';
import { SpadesOverlay } from './SpadesOverlay';
import { SpadesTable3D } from './SpadesTable3D';
import { SpadesVRPanel } from './SpadesVR';
import type { GameClientDef } from '../types';

export const spadesClient: GameClientDef = {
  kind: 'spades',
  label: 'Spades',
  blurb: 'Partnership card game for 4 — bid your tricks, first team to 500.',
  icon: Spade,
  glyph: '♠',
  category: 'table',
  minPlayers: 4,
  maxPlayers: 4,
  bots: true,
  seatNames: SEAT_NAMES,
  ranking: 'wins',
  chairs: [0, 1, 2, 3].map((i) => { const [x, z] = seatXZ(i); return { x, z, yaw: seatYaw(i) }; }),
  Furniture: CardTableSet,
  Table3D: SpadesTable3D,
  Overlay: SpadesOverlay,
  VRPanel: SpadesVRPanel,
  rules: SPADES_RULES,
  tutorial: { url: SPADES_TUTORIAL_URL, title: SPADES_TUTORIAL_TITLE },
};
